import * as maplibregl from 'maplibre-gl'
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'

// MapLibre 6 looks for its worker next to its own module file. Once Vite has
// bundled that file into a hashed chunk the sibling does not exist, the SPA
// fallback answers with index.html, and the map renders no tiles. Hand it the
// worker Vite emits instead. Every map imports MapLibre from here so this runs
// before the first `new Map()`.
maplibregl.setWorkerUrl(workerUrl)

export { maplibregl }
